import { useDisclosure } from '@chakra-ui/react'
import { selectAuthenticatedUser, useSelector } from '@missionlabs/api'
import { UserRole } from '@missionlabs/types'
import { FC, useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useUserRole } from 'shared/hooks/useUserRole'
import { useGetSpeedDialsForClientQuery, useGetSpeedDialsForUserQuery } from 'shared/store'

import { AddEditNumberDrawer } from './AddEditNumber/AddEditNumberDrawer'
import { SpeedDial } from './SpeedDial'

export interface SpeedDialDashboardProps {}

export const SpeedDialDashboard: FC<SpeedDialDashboardProps> = () => {
    const { pathname } = useLocation()
    const { isOpen: addOpen, onClose: addOnClose, onOpen: addOnOpen } = useDisclosure()

    const [editing, setEditing] = useState<boolean>()

    const { userID = '' } = useSelector(selectAuthenticatedUser) ?? {}
    const userRole = useUserRole()

    const { speedDialCode } = useParams()

    const isAdmin = useMemo(
        () => pathname.includes('/admin/') && userRole === UserRole.ADMIN,
        [userRole, pathname]
    )

    const { data: clientSpeedDials = [], isLoading: isLoadingForClient } =
        useGetSpeedDialsForClientQuery(undefined, { skip: !userID })

    const { data: userSpeedDials = [], isLoading: isLoadingForUser } = useGetSpeedDialsForUserQuery(
        { userID },
        { skip: !userID || isAdmin }
    )

    useEffect(() => {
        if (!speedDialCode) return

        if (speedDialCode === 'add') {
            setEditing(false)
        } else {
            setEditing(true)
        }

        addOnOpen()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [speedDialCode, isAdmin])

    return (
        <>
            <AddEditNumberDrawer
                isAdmin={isAdmin}
                editing={editing}
                isOpen={addOpen}
                onClose={addOnClose}
            />

            <SpeedDial
                isAdmin={isAdmin}
                userSpeedDials={userSpeedDials}
                isLoadingForUser={isLoadingForUser}
                clientSpeedDials={clientSpeedDials}
                isLoadingForClient={isLoadingForClient}
            />
        </>
    )
}
